import { Chip } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useTransition, animated } from 'react-spring';
import { cursorTo } from 'readline';
import SvgIcon from '../../svg/SvgIcon';

interface FollowUpListProps {
  questions: string[];
  setMessage: (message: string) => void;
  inputElement?: HTMLInputElement | null;
}


const FollowUpList: React.FC<FollowUpListProps> = ({ questions, setMessage,inputElement }) => {
  const [visibleQuestions, setVisibleQuestions] = useState<string[]>([]);

  useEffect(() => {
    // Push all questions immediately (no delay)
    setVisibleQuestions(questions);
  }, [questions]);

  const transitions = useTransition(visibleQuestions, (item) => item, {
    from: { opacity: 0, transform: 'translateY(-20px) scale(0.9)' },
    enter: { opacity: 1, transform: 'translateY(0px) scale(1)' },
    leave: { opacity: 0, transform: 'translateY(-20px) scale(0.9)' },
    config: { tension: 200, friction: 20 },
  });

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {transitions.map(({ item, key, props }) => (
        <animated.div key={key} style={props}>
          <Chip 
            label={item}
            avatar={
                <SvgIcon className="chat-icon" id="chat-icon" width="16" height="16" />
            } 
            variant="outlined" 
            onClick={() => {
                setMessage(item.trim());
                if (inputElement) {
                    inputElement.focus();
                    // Move cursor to end of input
                    const length = inputElement.value.length;
                    inputElement.setSelectionRange(length, length);
                }
            }}
            className='follow-up-chip'
            color='default'
           />
        </animated.div>
      ))}
    </div>
  );
};

export default FollowUpList;
